var map = {
	"./CompactHeader.tsx": 57543,
	"./Footer.tsx": 52805,
	"./Header.tsx": 2153,
	"./HomePage.tsx": 65931,
	"./Layout.tsx": 34905,
	"./SharedContent.tsx": 7110,
	"./SignInPage.tsx": 14492,
	"./UnhandledErrorModal.tsx": 70052,
	"./VariantRootPage.tsx": 19226
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32507;